import makeStyles from "@mui/styles/makeStyles";
import AgyleToggleButtons from "../../../components/ui/buttons/agyleToggleButtons";
import React from "react";
import AdmissionInformation from "./information/information";
import AdmissionsCalendar from "./calendar/admissionsCalendar";
import {useDispatch, useSelector} from 'react-redux';
import {agylePref} from '../../../store/reducers/preferences';
import {getContentView, setContentView} from '../../../store/reducers/booked_admissions';
import {dispatch} from '@svgdotjs/svg.js';

export const useStyles = makeStyles((theme) => ({
    admissionCard: {
        height: 100,
        background: "#3d3e40",
        margin: "5px 0 5px 0",
        borderRadius: 5,
        borderLeft: "5px solid red",
        padding: 5
    },
    bookAdmissionToggle_classNameRoot: {
        color: theme.palette.mode === "dark" ? "black" : "#f3f3f4",
        backgroundColor: theme.palette.mode === "dark" ? "#313233" : "#bfc2c7",
        padding: 3,
        marginLeft: 55
    },
    bookAdmissionToggle_classNameLabel: {
        color: theme.palette.mode === "dark" ? "#ACAFB3" : "#f3f3f4",
    },
    bookAdmissionToggle_classNameSelected: {
        color: theme.palette.mode === "dark" ? "black !important" : "#ffffff !important",
        fontWeight:  theme.palette.mode === "dark" ? 400 : 600,
        backgroundColor: theme.palette.mode === "dark" ? "#ffffff !important" : "#626466 !important"
    },
}));

export const contentViewTypes = {
    SCHEDULE: "SCHEDULE",
    INFORMATION: "INFORMATION",
}



const AdmissionContent = (props) => {
    const classes = useStyles();


    //const [view, setView] = React.useState(contentViewTypes.SCHEDULE);
    const dispatch = useDispatch();

    const view = useSelector(getContentView);

    return(<div style={{width: "100%"}}>
        <div style={{position: "absolute"}}>
            <AgyleToggleButtons
                classNameRoot={classes.bookAdmissionToggle_classNameRoot}
                classNameLabel={classes.bookAdmissionToggle_classNameLabel}
                classNameSelected={classes.bookAdmissionToggle_classNameSelected}
                onChange={(e)=>{
                    if(e) dispatch(setContentView(e))
                }}
                value={view}
                size="small"
                options={[
                    {value: contentViewTypes.SCHEDULE, label: "Calendar"},
                    {value: contentViewTypes.INFORMATION, label: "Information"}
                ]}
                minWidth={100}
            />
        </div>

        {view === contentViewTypes.INFORMATION && <AdmissionInformation/>}
        {view === contentViewTypes.SCHEDULE && <AdmissionsCalendar/>}
    </div>);
}


export default AdmissionContent